import { Box, IconButton } from "@mui/material";

import BreadcrumbsHeader from "./breadcrumbsHeader";
import { ReactComponent as IconChevronLeft } from "assets/svg/20-arrow-left.svg";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

const DefaultHeader = () => {
  const location = useLocation();
  const lastPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    lastPathRef.current = location.pathname;
  }, [location.pathname]);

  const handleBack = () => {
    const currentPath = location.pathname;
    const currentIdx = (window.history.state as any)?.idx || 0;

    window.history.back();

    setTimeout(() => {
      const newPath = window.location.pathname;
      const newIdx = (window.history.state as any)?.idx || 0;

      if (currentPath === newPath && currentIdx !== newIdx) {
        window.history.back();
      }
    }, 100);
  };

  return (
    <Box
      display="flex"
      alignItems={"center"}
      pr={{ xs: 1, xl: 3 }}
      flex={1}
      paddingLeft={3}
      gap={2}
    >
      <IconButton onClick={handleBack} sx={{ padding: 0 }}>
        <IconChevronLeft />
      </IconButton>
      <BreadcrumbsHeader />
    </Box>
  );
};

export default DefaultHeader;
